import {
  Box,
  Typography,
  useTheme
} from '@mui/material';
import { ActivityDetailSectionCardBaseLayout } from 'modules/components/layer16';
import { SaveClientReportModal } from 'modules/components/layer17';
import React, { useState } from 'react';

export type ClientReportDescriptionCardProps = {
  id: string;
  description: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportDescriptionCardProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  const theme = useTheme();
  return (
    <>
      {isVisible && (
        <SaveClientReportModal.FC
          id={props.id}
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <ActivityDetailSectionCardBaseLayout.FC
        title='General'

        subTitle='Summarize any information to be displayed to client'
        actionButton={null}
        editActionButton={{
          onClick: () => {
            setIsVisible(() => true);
          },
          text: 'Edit'
        }}
        boxProps={{
          flex: '1 1 0'
        }}
      >

        <Box
          bgcolor={theme.palette.secondary.main}
          borderRadius='1rem'
          padding='1rem'
          minHeight='10rem'
        >

          <Typography
            variant='body1'
          >
            {props.description}
          </Typography>

        </Box>

      </ActivityDetailSectionCardBaseLayout.FC>
    </>
  );
};
